// extracted by mini-css-extract-plugin
module.exports = {"SkillsWrapper":"skills_SkillsWrapper__1IOKs","SkillList":"skills_SkillList__Lcqn5","grow":"skills_grow__2av8X"};